function waitForjQuery(trigger) {
  var interval = setInterval(function () {
    if (window.jQuery !== undefined) {
      clearInterval(interval);
      trigger(window.jQuery);
    }
  }, 50);
  setTimeout(function () {
    clearInterval(interval);
  }, 15000);
}
// Before after effect
waitForjQuery(function () {
  // Before after effect
  $(document).ready(function () {
    $(".nira-before-after .r_beforeAfterContent").each(function (i, el) {
      $(el)
        .find("#control")
        .draggable({
          axis: "x",
          containment: "parent",
          drag: function (e, ui) {
            $(el)
              .find("#r_a_before")
              .css("width", ui.position.left + 34 + "px");
          },
        })
        .trigger("drag");
    });
    function before_after_height(){
      const before_image_height = $('#r_beforeImg').height();
      console.log(before_image_height)
      $('#r_slideInner').height(before_image_height+'px');
    }
    before_after_height();
    $(window).resize(function(){
     before_after_height();
    });
  });
  // Scroll to review section
  $(document).on("click", ".review-text-section", function () {
    $("html, body").animate({
      scrollTop: $(".how-to-use-page-review").position().top,
    });
  });
});
